export default __webpack_public_path__ + "2b4b10544dd9a5b34a77d2388fb3bef3.jpg";